import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import attachValidation from '../../utils/form-validation';
import { getDataFromForm } from '../../utils/misc';

class EditMyEmployment {
	constructor() {
		this.schoolsList = [];
		this._container = SelectorEngine.findOne('.js-edit-coach-details-my-employment');
		this.employmentStatus = '';
		this.limitedCompany = '';
		this.onCourtEmployees = '';

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-my-employment-form', this._container);

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-my-employment-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-my-employment-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-my-employment-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-my-employment-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._companyWrapper = SelectorEngine.findOne('.lta-coach-details__edit-my-employment-company', this._container);

		this._courtsWrapper = SelectorEngine.findOne('.lta-coach-details__edit-my-employment-courts', this._container);

		this._tooltipWrapper = SelectorEngine.findOne('.lta-coach-details__edit-my-employment-tooltip', this._container);

		this._limitedCompanyRadios = SelectorEngine.find('input[name="limitedCompany"]', this._form);
		this._courtEmployeesRadios = SelectorEngine.find('input[name="courtEmployees"]', this._form);

		this._form.addEventListener('change', () => {
			this._changeHandler();
		});

		this._errorContainer = SelectorEngine.findOne('.lta-edit-my-employment-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this.fv = attachValidation(this._form, {
			employment: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			},
			limitedCompany: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			},
			courtEmployees: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			}
		});

		this.fv.on('core.form.valid', () => {
			this.submitEnquiry(this._form);
		});

		this.disableFormValidations();
		this._changeHandler();
	}

	disableFormValidations() {
		this.fv.disableValidator('limitedCompany');
		this.fv.disableValidator('courtEmployees');
	}

	_changeHandler() {
		const employmentStatus = SelectorEngine.findOne('input[name = "employment"]:checked', this._form);
		const limitedCompany = SelectorEngine.findOne('input[name = "limitedCompany"]:checked', this._form);
		const courtEmployees = SelectorEngine.findOne('input[name = "courtEmployees"]:checked', this._form);

		if (employmentStatus.value === 'Self-Employed') {
			this._companyWrapper.classList.remove('u-hidden');
			this.fv.enableValidator('limitedCompany');
		} else {
			// Clear selections
			this._limitedCompanyRadios.forEach((radio) => {
				radio.checked = false;
			});

			this._courtEmployeesRadios.forEach((radio) => {
				radio.checked = false;
			});

			this._companyWrapper.classList.add('u-hidden');
			this._courtsWrapper.classList.add('u-hidden');
			this._tooltipWrapper.classList.add('u-hidden');
			this.fv.disableValidator('limitedCompany');
			this.fv.disableValidator('courtEmployees');
		}

		if (limitedCompany !== null) {
			if (limitedCompany.value === 'true' && employmentStatus.value === 'Self-Employed') {
				this._courtsWrapper.classList.remove('u-hidden');
				this.fv.enableValidator('courtEmployees');
			} else {
				this._courtEmployeesRadios.forEach((radio) => {
					radio.checked = false;
				});

				this._courtsWrapper.classList.add('u-hidden');
				this._tooltipWrapper.classList.add('u-hidden');
				this.fv.disableValidator('courtEmployees');
			}
		}

		if (courtEmployees !== null) {
			if (
				courtEmployees.value === '2 or More' &&
				limitedCompany.value === 'true' &&
				employmentStatus.value === 'Self-Employed'
			) {
				this._tooltipWrapper.classList.remove('u-hidden');
			} else {
				this._tooltipWrapper.classList.add('u-hidden');
			}
		} else {
			this._tooltipWrapper.classList.add('u-hidden');
		}
	}

	async submitEnquiry(form) {
		stopLoadingAnimation();

		const dataObject = getDataFromForm(form);

		this.employmentStatus = dataObject.employment;
		if (dataObject.employment != 'Self-Employed') {
			this.limitedCompany = '';
			this.onCourtEmployees = '';
		} else if (dataObject.limitedCompany == 'false') {
			this.limitedCompany = dataObject.limitedCompany;
			this.onCourtEmployees = '';
		} else {
			this.limitedCompany = dataObject.limitedCompany;
			this.onCourtEmployees = dataObject.courtEmployees;
		}

		const payload = {
			updateCoachDetailsRequest: {
				myEmployment: {
					employmentStatus: dataObject.employment,
					limitedCompany: this.limitedCompany,
					onCourtEmployees: this.onCourtEmployees
				}
			}
		};

		console.log(payload);

		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			startLoadingAnimation();
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditMyEmployment = new EditMyEmployment();

export default globalEditMyEmployment;
